export const CERTIFICATION = "CERTIFICATION"
export const DIPLOMA = "DIPLOMA"
export const MASTER = "MASTER"
